export default {
  type: 'menu',
  code: '10000000',
  addCA: {
    type: 'btns',
    code: '10010000'
  },
  deleteCA: {
    type: 'btns',
    code: '10020000'
  }
}
